import { useMocks } from '../../shared/env';
import type { TimeAndLeaveGateway } from './TimeAndLeaveGateway';
import { HttpTimeAndLeaveGateway } from './HttpTimeAndLeaveGateway';
import { MockTimeAndLeaveGateway } from './MockTimeAndLeaveGateway';

export const timeAndLeaveGateway: TimeAndLeaveGateway = useMocks ? new MockTimeAndLeaveGateway() : new HttpTimeAndLeaveGateway();
export type { TimeAndLeaveGateway } from './TimeAndLeaveGateway';
